import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const iabiletBaseUrl = process.env.REACT_APP_IABILET_BASE_URL;
const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

const TopNavBar = () => (
    <header id="header" className="header-simple sticky-top">
        <Navbar
            data-bs-theme="dark"
            expand="lg"
            className="p-0 navbar-header navbar-dark bg-dark"
            aria-label="navbar"
        >
            <Container fluid>
                <a
                    role="button"
                    tabIndex={0}
                    href={iabiletBaseUrl}
                    className={`me-2 button-nav-brand btn ${isProduction ? 'btn-primary' : 'btn-danger'}`}
                >
                    <strong>IB</strong>
                </a>
                <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Toggle navigation" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="w-100">
                        <Nav.Link href={`${iabiletBaseUrl}/admin`}>Admin</Nav.Link>
                        <Nav.Link as={Link} to="/admin" className="active d-inline-flex align-items-center">
                            <i className="bi bi-chevron-right me-2" aria-hidden="true" />
                            IBQueue
                        </Nav.Link>
                        <Nav.Link href={`${iabiletBaseUrl}/auth/logout`} className="ms-lg-auto">
                            Logout
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </header>
);

export default TopNavBar;
